import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchData,
  menudataSelector,
  setNeedsUpdate
} from "reducers/menudata/menudata";
import {
  menuitem_setData,
  menuitem_update,
  menuitemSelector,
  saveData
} from "reducers/menuitem/menuitem";
import { useParams } from "react-router-dom";
import Loader from "components/Loading/Loader";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { deepEqual } from "helpers/MediatelHelper";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { variationPlacements } from "@popperjs/core";
import { useNavigate } from "react-router-dom";

import {
  appdataSelector
} from "reducers/appdata/appdata";


{
  /*https://react-table.tanstack.com/docs/examples/material-ui-components*/
}

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#008752"
    }
  },
  backdrop: {
    zIndex: 9999999,
    color: "#000"
  }
});

function MenuItem(props) {
  const navigate = useNavigate();
  const appdata = useSelector(appdataSelector);
  let { menu_numb } = useParams();
  let buttonTitle = menu_numb ? "Update Menu" : "Create Menu";
  console.log("MenuItem - menu_numb passed in params: ", menu_numb);
  const menudata = useSelector(menudataSelector);
  const menuitem = useSelector(menuitemSelector);
  const dispatch = useDispatch();
  const [savedToSAP, setSavedToSAP] = React.useState(true);
  const [init,setInit] = React.useState(true);

  useEffect(() => {
    if (savedToSAP) {
      if (init){
        console.log("menuitem - saved initial state")
        setInit(false);
        return;
      }

      navigate("/app/menus");

      console.log("menuitem - saved saved to sap, should redirect");
    }
  }, [savedToSAP]);

  useEffect(() => {
    //once

    console.log("MenuItem Created", menudata);

    dispatch(menuitem_setData(null));

    if (menudata && !menudata.loaded) {
      console.log("MenuItem - menudata not loaded yet, should go get data");
      dispatch(fetchData());
    }
  }, []);

  useEffect(() => {
    console.log("menuitem updated", menuitem.data);
    if (!menuitem.dataSAP && (!menuitem.data || menuitem.data == [])) {
      if (!savedToSAP) setSavedToSAP(true);
      return;
    }

    if (!menuitem.dataSAP && menuitem.data && menuitem.data != []) {
      if (savedToSAP) setSavedToSAP(false);
      return;
    }

    console.log("menuitem updated", menuitem.data, menuitem.dataSAP);
    if (!deepEqual(menuitem.data, menuitem.dataSAP)) {
      console.log("menuitem not saved");
      if (savedToSAP) setSavedToSAP(false);
    } else {
      console.log("menuitem saved");
      if (!savedToSAP) setSavedToSAP(true);
    }
  }, [menuitem]);

  // no data yet
  // no data yet
  // no data yet
  // no data yet
  if (!menudata) {
    console.log("no data");
    return <div>no data</div>;
  }

  // data set, but loading
  // data set, but loading
  // data set, but loading
  // data set, but loading
  if (menudata.loading) {
    return (
      <div className="loader-container">
        {" "}
        Loading...<br></br>
        <br></br> <Loader w="25" />{" "}
      </div>
    );
  }

  if (menudata.loaded && menu_numb && !menuitem.data) {
    console.log("update menuitem based on menu_numb");
    Object.keys(menudata.data.lunchMenuItems).map(key => {
      let item = menudata.data.lunchMenuItems[key];
      if (parseInt(item.MENU_NUMB) == parseInt(menu_numb)) {
        dispatch(menuitem_setData(item));
      }
    });
  }

  console.log("before render", menuitem, menudata);

  if (!menudata.loaded) {
    return;
  }

  const handleAllergyChange = (allergyCode, value) => {
    console.log("check", allergyCode, value);
    // update allergy list based on current list (add or remove)

    let currentAllergies =
      menuitem.data && menuitem.data.MENU_ALGEN ? menuitem.data.MENU_ALGEN : "";
    let currentList = currentAllergies == "" ? [] : currentAllergies.split(",");
    console.log("current", currentList);
    // remove
    if (currentList.includes(allergyCode) && value == false) {
      let index = currentList.indexOf(allergyCode);
      currentList.splice(index, 1);
    }

    if (!currentList.includes(allergyCode) && value == true) {
      currentList.push(allergyCode);
      currentList.sort();
    }

    console.log("current", currentList);

    let newList =
      currentList.length > 1 ? currentList.join(",") : currentList[0];

    dispatch(menuitem_update({ MENU_ALGEN: newList }));
  };

  return (
    <Grid
      className="mt-2"
      container
      spacing={2}
      alignItems="top"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} md={10}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Card>
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <h2 className="article-title">
                    MenuItem{menu_numb ? " (" + menu_numb + ")" : ""}
                  </h2>
                  <TextField
                    className="mt-4"
                    disabled
                    id="outlined-disabled"
                    label="Id"
                    defaultValue={
                      menu_numb ? menu_numb : "auto created upon save"
                    }
                  />
                  <br></br>
                  {/* active flag */}
                  {/* active flag */}
                  {/* active flag */}
                  {/* active flag */}
                  <div className="mt-3">
                    <b>Active:</b>
                  </div>
                  <div className="mt-3">
                    <FormControlLabel
                      key={"activeFlagLabel"}
                      control={
                        <Checkbox
                          style={{
                            paddingTop: 0,
                            paddingBottom: 0,
                            marginLeft: 10
                          }}
                          checked={
                            menuitem.data &&
                            menuitem.data.DEACTIVATE &&
                            menuitem.data.DEACTIVATE == "X"
                              ? false
                              : true
                          }
                          onChange={event => {
                            dispatch(
                              menuitem_update({
                                DEACTIVATE: event.target.checked ? "" : "X"
                              })
                            );
                          }}
                        />
                      }
                      label={"Item is active"}
                    />
                  </div>
                  <br></br>
                  {/* menu name DE */}
                  {/* menu name DE */}
                  {/* menu name DE */}
                  {/* menu name DE */}
                  {/* menu name DE */}
                  <TextField
                    fullWidth
                    className=""
                    id="outlined"
                    label="Name (EN)"
                    onChange={event => {
                      dispatch(
                        menuitem_update({ MENU_EN: event.target.value })
                      );
                    }}
                    value={
                      menuitem.data &&
                      menuitem.data.MENU_EN &&
                      menuitem.data.MENU_EN != undefined
                        ? menuitem.data.MENU_EN
                        : ""
                    }
                    InputLabelProps={{
                      shrink:
                        menuitem.data && menuitem.data.MENU_EN ? true : false
                    }}
                  />
                  <br></br>
                  {/* menu name EN */}
                  {/* menu name EN */}
                  {/* menu name EN */}
                  {/* menu name EN */}
                  {/* menu name EN */}
                  <TextField
                    fullWidth
                    className="mt-4"
                    id="outlined"
                    label="Name (DE)"
                    key="key1"
                    onChange={event => {
                      dispatch(
                        menuitem_update({ MENU_DE: event.target.value })
                      );
                    }}
                    value={
                      menuitem.data &&
                      menuitem.data.MENU_DE &&
                      menuitem.data.MENU_DE != undefined
                        ? menuitem.data.MENU_DE
                        : ""
                    }
                    InputLabelProps={{
                      shrink:
                        menuitem.data &&
                        menuitem.data.MENU_DE &&
                        menuitem.data.MENU_DE
                          ? true
                          : false
                    }}
                  />
                  {/* soup flag */}
                  {/* soup flag */}
                  {/* soup flag */}
                  {/* soup flag */}
                  <div className="mt-3 mb-3">
                    <b>Soup:</b>
                  </div>
                  <div className="mt-3">
                    <FormControlLabel
                      key={"soupFlagLabel"}
                      control={
                        <Checkbox
                          style={{
                            paddingTop: 0,
                            paddingBottom: 0,
                            marginLeft: 10
                          }}
                          checked={
                            menuitem.data &&
                            menuitem.data.SOUP_FLAG &&
                            menuitem.data.SOUP_FLAG == "X"
                              ? true
                              : false
                          }
                          onChange={event => {
                            dispatch(
                              menuitem_update({
                                SOUP_FLAG: event.target.checked ? "X" : ""
                              })
                            );
                          }}
                        />
                      }
                      label={"This is a soup"}
                    />
                  </div>
                  {/* allergies */}
                  {/* allergies */}
                  {/* allergies */}
                  {/* allergies */}
                  {/* allergies */}
                  <div className="mt-3 mb-3">
                    <b>Allergies:</b>
                  </div>

                  <FormGroup style={{ marginTop: 0, marginLeft: 10 }}>
                    {Object.keys(menudata.data.allergies).map(key => {
                      // the allergies selected for the menu
                      let code = menudata.data.allergies[key]["ALGEN_CODE"];
                      // the allergy
                      let codes =
                        menuitem.data && menuitem.data.MENU_ALGEN
                          ? menuitem.data.MENU_ALGEN
                          : [];

                      // is the allergy selected for the menu?
                      let isChecked = codes.includes(code) ? true : false;

                      return (
                        <FormControlLabel
                          key={"allergycontrol" + key}
                          control={
                            <Checkbox
                              style={{ paddingTop: 0, paddingBottom: 0 }}
                              key={"allergy" + key}
                              checked={isChecked}
                              onChange={event => {
                                handleAllergyChange(code, event.target.checked);
                              }}
                            />
                          }
                          label={
                            "(" +
                            code +
                            ") " +
                            menudata.data.allergies[key]["ALGEN_" + appdata.language]
                          }
                        />
                      );
                    })}
                  </FormGroup>

                  {menuitem.saving && (
                    <div className="mt-4 pl-4">
                      <Loader w="25" />
                    </div>
                  )}

                  {!savedToSAP && !menuitem.saving && (
                    <div className="mt-4">
                      <Button
                        variant="contained"
                        onClick={() => {
                          dispatch(saveData());
                          dispatch(setNeedsUpdate(true));
                        }}
                      >
                        {buttonTitle}
                      </Button>
                    </div>
                  )}
                  {savedToSAP && menuitem.data && menuitem.data.MENU_NUMB && (
                    <div className="mt-4">Item is stored in SAP</div>
                  )}
                </div>
              </article>
            </Card>
            <Card className="mt-4 d-none">
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <div>
                    <h2 className="article-title mb-4">Todo's</h2>
                    <ul>
                      <li>
                        <s>Add inactivity flag field</s>
                      </li>
                      <li>
                        <s>Disable update/submit button when submitting</s>
                      </li>
                      <li>
                        <s>Feedback on update/submit </s>
                      </li>
                      <li>
                        <s>
                          Add delete menu button <b>no</b>
                        </s>
                      </li>
                      <s>
                        This can not be done without consequences. A menu should
                        not be deleted if it is still active in any schedule, or
                        is due for payment
                      </s>
                    </ul>
                  </div>
                </div>
              </article>
            </Card>
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}

export default MenuItem;
